var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      ref: "stepForm",
      attrs: { model: _vm.formData, rules: _vm.rules },
    },
    [
      _c(
        "el-row",
        { attrs: { gutter: 15 } },
        [
          _c(
            "el-col",
            { staticClass: "form-step-title", attrs: { span: 24 } },
            [_c("div", { staticClass: "steptitle" }, [_vm._v("Payment")])]
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { sm: 24, md: 11 } },
            [
              _c(
                "el-radio",
                {
                  attrs: { label: "card" },
                  model: {
                    value: _vm.formData.method,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "method", $$v)
                    },
                    expression: "formData.method",
                  },
                },
                [_vm._v("I want to pay with credit card")]
              ),
              _vm._v(" "),
              _vm.formData.method == "card"
                ? _c(
                    "div",
                    [
                      _c("img", {
                        staticClass: "paymentcards",
                        attrs: { src: "/images/cards.svg" },
                      }),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Card Number", prop: "cardnumber" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "1111 2222 3333 4444" },
                            model: {
                              value: _vm.formData.cardnumber,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "cardnumber", $$v)
                              },
                              expression: "formData.cardnumber",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 15 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Exp. Month",
                                    prop: "cardmonth",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "MM", size: "2" },
                                    model: {
                                      value: _vm.formData.cardmonth,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "cardmonth", $$v)
                                      },
                                      expression: "formData.cardmonth",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Exp. Year",
                                    prop: "cardyear",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "YY", size: "2" },
                                    model: {
                                      value: _vm.formData.cardyear,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "cardyear", $$v)
                                      },
                                      expression: "formData.cardyear",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "CVV", prop: "cvv" } },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "123" },
                                    model: {
                                      value: _vm.formData.cvv,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "cvv", $$v)
                                      },
                                      expression: "formData.cvv",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 15 } },
                        [
                          _c("el-col", { attrs: { span: 12 } }, [
                            _vm._v(" Billing Address "),
                          ]),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.billing.address1) +
                                "\n                        " +
                                _vm._s(_vm.billing.address2) +
                                "\n                        " +
                                _vm._s(
                                  _vm.billing.city + ", " + _vm.billing.postcode
                                ) +
                                "\n                        " +
                                _vm._s(_vm.billing.country) +
                                "\n                    "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c(
                "el-radio",
                {
                  attrs: { label: "bank" },
                  model: {
                    value: _vm.formData["method"],
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "method", $$v)
                    },
                    expression: "formData['method']",
                  },
                },
                [_vm._v("Payment method bank transfer")]
              ),
              _vm._v(" "),
              _vm.formData.method == "bank"
                ? _c(
                    "div",
                    { staticStyle: { width: "100%" } },
                    [
                      _c("div", { staticClass: "banktransfer-note" }, [
                        _vm._v(
                          "\n                    Wire - Electronic Bank Transfer Details\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bankpayment-details" },
                        [
                          _vm._v(
                            "\n                    All payments must be made at:"
                          ),
                          _c("BR"),
                          _vm._v(" "),
                          _c("strong", [_vm._v("METROPOLITAN ARTS PRESS LTD")]),
                          _c("BR"),
                          _vm._v(" Bank:\n                    US BANK"),
                          _c("BR"),
                          _vm._v(" Account Number: 1964 7758 8525"),
                          _c("BR"),
                          _vm._v(
                            "\n                    Routing Number: 073000545"
                          ),
                          _c("BR"),
                          _vm._v(" Swift Code: 073000545"),
                          _c("BR"),
                          _vm._v(
                            "\n                    Bank Address: 270 West 7th Street Dubuque IA\n                    52001-2376"
                          ),
                          _c("BR"),
                          _vm._v(" "),
                          _c("ul", [
                            _c("li", [
                              _vm._v(
                                "\n                            Please send us the bank transfer receipt with\n                            your payment at\n                            "
                              ),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "mailto:contact@globaldesignnews.com",
                                  },
                                },
                                [_vm._v("contact@globaldesignnews.com")]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _vm._v(
                                "\n                            Remember to include the reference ID number of\n                            your submission\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _vm._v(
                                "\n                            Entry fee for each submission is\n                            "
                              ),
                              _c("strong", [_vm._v(_vm._s(_vm.payAmount))]),
                              _vm._v(
                                ". After we receive your submission and check\n                            all materials an invoice will be sent to your\n                            email.\n                        "
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "banktransfer-note" }, [
                        _vm._v(
                          "\n                    Important: Add $25.00 USD for Bank Service Charges for\n                    wire transfers.\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "bankdocument",
                          attrs: {
                            href: "pdf/banktransfer_fh.pdf",
                            target: "_blank",
                          },
                        },
                        [_vm._v("Download Bank payment details")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 15 } },
                        [
                          _c("el-col", { attrs: { span: 12 } }, [
                            _vm._v(" Billing Address "),
                          ]),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.billing.address1) +
                                "\n                        " +
                                _vm._s(_vm.billing.address2) +
                                "\n                        " +
                                _vm._s(
                                  _vm.billing.city + ", " + _vm.billing.postcode
                                ) +
                                "\n                        " +
                                _vm._s(_vm.billing.country) +
                                "\n                    "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { sm: 24, md: { span: 10, offset: 3 } } },
            [
              _c("div", [_vm._v("Purchase summary")]),
              _vm._v(" "),
              _c("div", { staticClass: "billnotice" }, [
                _vm._v("Billed in Euros ($)"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "linebill" }, [
                _c("div", { staticClass: "billtext" }, [
                  _vm._v(
                    "\n                    One submission for Prize Designs Award\n                "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "billamount" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.payAmount) +
                      "\n                "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("div", { staticClass: "linebill" }, [
                _c("div", { staticClass: "billtext" }, [_vm._v("Total")]),
                _vm._v(" "),
                _c("div", { staticClass: "billamount" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.payAmount) +
                      "\n                "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm.formData.method == "card"
                ? _c(
                    "el-button",
                    {
                      staticClass: "form-submit",
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v("Pay now\n            ")]
                  )
                : _c(
                    "el-button",
                    {
                      staticClass: "form-submit",
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v("Complete submission\n            ")]
                  ),
              _vm._v(" "),
              _c("div", { staticClass: "refundpolicy" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://globaldesignnews.com/terms-and-conditions/",
                      target: "_blank",
                    },
                  },
                  [_vm._v("Learn about our Refund Policy")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "invoiceto" }, [
                  _vm._v(
                    "\n                    Your invoice will be sent to " +
                      _vm._s(_vm.billing.email) +
                      "\n                "
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "form-buttons" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }